import React, { useState } from 'react';
import {
    useModalsContext,
    useStoreConfigContext,
    useWishListsContext
} from '/src/providers';
import {
    Errors,
    Form, H2,
    Loader,
    Modal,
    useForm
} from '/src/components';
import Item from './Item';
import WishListForm from './WishListForm';
import * as styles from './styles.scss'

const WishLists = ({
    sku,
    filterWishLists = f => f,
    isAddNewWishList = true,
    title,
    ...props
}) => {
    const { translate } = useStoreConfigContext();
    const { hideModal } = useModalsContext();
    const {
        wishLists,
        isLoadingWishLists,
        createWishList,
        WISH_LIST_STATUSES,
    } = useWishListsContext();
    const [addingInProgress, setAddInProgress] = useState(false);
    const {
        data,
        errors,
        setErrors,
        resetForm,
        handleChange
    } = useForm({ name: '', visibility: false });
    const filteredWIshLists = filterWishLists(wishLists);

    const handleCreateWishList = e => {
        e.preventDefault();
        const { name, visibility } = data;

        createWishList({
            input: {
                name,
                visibility: visibility ? WISH_LIST_STATUSES.PRIVATE : WISH_LIST_STATUSES.PUBLIC
            }
        }).then(() => {
            resetForm();
            setAddInProgress(false);
        }).catch(errors => setErrors(errors));
    };

    const handleError = f => f
        .then(response  => {
            if (errors) {
                setErrors(null);
            }

            return response;
        }).catch(errors => setErrors(errors));

    return (
        <Modal { ...(!isLoadingWishLists ? { toggle: hideModal } : {}) }>
            <H2 className={styles.title}>
                {title}
            </H2>
            <Errors errors={errors} />
            <Loader isLoading={isLoadingWishLists}>
                {
                    !!filteredWIshLists.length &&
                    <div className={styles.list}>
                        {
                            filteredWIshLists.map(({
                                id,
                                name,
                                visibility,
                                items_count,
                                items_v2: {items}
                            }) => {
                                const wishListItem = items.find(({product}) => product.sku === sku);

                                return (
                                    <Item
                                        key={id}
                                        wishListId={id}
                                        sku={sku}
                                        name={name}
                                        visibility={visibility === WISH_LIST_STATUSES.PRIVATE}
                                        wishListItemId={wishListItem?.id}
                                        handleError={handleError}
                                        {...props}
                                    >
                                        <span className={styles.count}>
                                            {`${translate('Items')}: ${items_count}`}
                                        </span>
                                    </Item>
                                )
                            })
                        }
                    </div>
                }
                {
                    isAddNewWishList &&
                    <>
                        {
                            !addingInProgress &&
                            <button
                                className={styles.link}
                                onClick={() => setAddInProgress(true)}
                            >
                                {translate('Create new wishlist')}
                            </button>
                        }
                        {
                            addingInProgress &&
                            <div className={styles.form}>
                                <WishListForm
                                    data={data}
                                    handleChange={handleChange}
                                    handleSubmit={handleCreateWishList}
                                    isLoadingWishLists={isLoadingWishLists}
                                />
                            </div>
                        }
                    </>
                }
                <Form.Column>
                    <Form.Button onClick={hideModal} disabled={isLoadingWishLists}>
                        {translate('Close')}
                    </Form.Button>
                </Form.Column>
            </Loader>
        </Modal>
    );
};

export default WishLists;
